import React from "react";
import { Instagram } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { Reveal } from "../components/Reveal";
import { Overline, SectionTitle, GoldButton } from "../components/site/Primitives";
import SEO from "../components/SEO";

export default function Sobre() {
  const { site } = useSite();
  const about = site?.about || {};
  const socials = site?.socials || {};
  const text = about.text || "";

  return (
    <div>
      <SEO title="Quem Somos | Barbearia das Estrelas e Prime Capilar Clinic" description="Conheça a história da Barbearia das Estrelas, da Prime Capilar Clinic e de Bruno Barber." />

      <section className="border-b border-white/10 py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal><Overline className="mb-3">Quem somos</Overline></Reveal>
          <Reveal delay={0.05}><SectionTitle className="max-w-3xl">Barbearia, estética masculina e soluções capilares</SectionTitle></Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-24 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <div className="space-y-5 text-zinc-300 leading-relaxed">
            {text.split("\n").filter(Boolean).map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden rounded-sm border border-white/12">
              <img src={about.owner_image} alt={about.owner_name} className="w-full h-full object-cover" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-6">
              <p className="font-heading font-700 uppercase text-white text-2xl">{about.owner_name}</p>
              <p className="text-gold text-sm">Barbearia e prótese capilar</p>
            </div>
          </div>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-24 text-center">
        <Reveal>
          <GoldButton href={socials.instagram_bruno || "#"} size="lg" data-testid="sobre-bruno-button">
            <Instagram className="w-5 h-5" /> CONHEÇA O BRUNO BARBER
          </GoldButton>
        </Reveal>
      </section>
    </div>
  );
}
